export const StepPillRenderer = (params: any, step: number) => {
  return (params.data.transactionData?.step ?? 1) === step ? (
    <div className="rounded-[6px] w-[25px] h-[18px] p-[4px] text-[10px] text-text-base flex items-center justify-center bg-bg-helper-green-dark"></div>
  ) : (
    <></>
  );
};
